export default __webpack_public_path__ + "static/media/20_desktop.90036f23.jpg";